import { ObjectPickerController } from '@components/hookFormControllers/ObjectPickerController'
import { ObjectPickerProps } from '@components/ui/ObjectPicker'

import { useReplaceVariablesInFilter, useVariables } from '@hooks'
import { ENTITY_TYPES_REQUEST, KIND_SEARCHABLE_FILTER_WORD } from '@constants'

import { EVENT_NAME } from '../../../../events'

type TProps = {
  generalFilterField?: string | null
  formId?: number
  isDialogWindow: boolean
} & Omit<
  ObjectPickerProps,
  | 'value'
  | 'onChange'
  | 'setValue'
  | 'invalid'
  | 'onLoadObject'
  | 'onChangeInDropdownEntityMode'
  | 'dataValue'
  | 'generalFilterField'
>

export const ObjectPickerControllerVariableWrapper = ({
  formId,
  generalFilterField,
  ...props
}: TProps) => {
  const inputVariables = useVariables({ id: formId, type: ENTITY_TYPES_REQUEST.FORM, formId })
  const globalVariables = useVariables({ isFetchAllVariables: true })

  const { updatedFilter } = useReplaceVariablesInFilter({
    rawFilter: generalFilterField,
    inputVariables,
    globalVariables,
    searchableFilterWord: KIND_SEARCHABLE_FILTER_WORD.FORM,
    event: EVENT_NAME.CHANGE_VARIABLE_VALUE,
    localEventBus: undefined,
  })

  return <ObjectPickerController formId={formId} generalFilterField={updatedFilter} {...props} />
}
